import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ChangePassword from "@/pages/ChangePassword";
import Dashboard from "@/pages/Dashboard";
import Distretto from "@/pages/Distretto";
import DivisionClubs from "@/pages/DivisionClubs";
import ClubDetail from "@/pages/ClubDetail";
import MemberDetail from "@/pages/MemberDetail";
import Events from "@/pages/Events";
import Admin from "@/pages/Admin";
import Layout from "@/components/Layout";

const Protected = ({ children, adminOnly }) => {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-navy">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/cambia-password" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/password-dimenticata" element={<ForgotPassword />} />
            <Route path="/reimposta-password" element={<ResetPassword />} />
            <Route path="/cambia-password" element={<ChangePassword />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/distretto" element={<Protected><Distretto /></Protected>} />
            <Route path="/distretto/divisioni/:division" element={<Protected><DivisionClubs /></Protected>} />
            <Route path="/club/:club" element={<Protected><ClubDetail /></Protected>} />
            <Route path="/soci/:id" element={<Protected><MemberDetail /></Protected>} />
            <Route path="/eventi" element={<Protected><Events /></Protected>} />
            <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
